import React from 'react';
import { ACTIVE_BLOCKS } from './blocks/registry';

// BlockRenderer — renders an ordered block list via the ACTIVE_BLOCKS registry. Fail-closed: an
// unknown or inactive block type renders nothing (the build-time validator prevents such content
// from shipping). Presentation only — no data ownership, no fetching.
export default function BlockRenderer({ blocks }) {
  if (!Array.isArray(blocks)) return null;
  return (
    <>
      {blocks.map((block, i) => {
        const Component = block && ACTIVE_BLOCKS[block.type];
        if (!Component) return null;
        return <Component key={i} {...block} />;
      })}
    </>
  );
}
